module.exports = __webpack_public_path__ + "static/media/mis_image1.ce417856.svg";